/* local storage constants */
export const USER_ID = 'id';

export const USER_NAME = 'name';

export const JWT_TOKEN = 'jwt-token';

export const USER_ORG_ID='orgId';

export const USER_EMAIL_ID='emailId';

